import React, { useState, useRef, useEffect } from 'react';
import { apiFetch } from '../utils/Api';
import OptionsModal from './Opties';

const EditCar = ({ car, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    merk: car.merk || '',
    model: car.model || '',
    uitvoering: car.uitvoering || '',
    kenteken: car.kenteken || '',
    gewicht: car.gewicht || '',
    transmissie: car.transmissie || '',
    aantalCilinders: car.aantalCilinders || '',
    carrosserie: car.carrosserie || '',
    aantalDeuren: car.aantalDeuren || '',
    pk: car.pk || '',
    motorinhoud: car.motorinhoud || '',
    kmstand: car.kmstand || '',
    brandstof: car.brandstof || '',
    kleur: car.kleur || '',
    interieurkleur: car.interieurkleur || '',
    apk: car.apk || '',
    omschrijving: car.omschrijving || '',
    opties: car.opties || '',
    datum: car.datum || '',
    prijs: car.prijs || '',
    aandrijving: car.aandrijving || '',
    aantalzitplaatsen: car.aantalzitplaatsen || '',
    bekledingsoort: car.bekledingsoort || '',
    imageLinks: car.imageLinks || [],
    inOfEXBTW: car.inOfEXBTW || '',
    verkocht: car.verkocht || false,
  });
  const modalRef = useRef();
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    car.opties ? car.opties.split(',').map(opt => opt.trim()) : []
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showOptionsModal) return;
      
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, showOptionsModal]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const processedData = {
        ...formData,
        id: car.id,
        gewicht: formData.gewicht ? parseInt(formData.gewicht) : 0,
        aantalCilinders: formData.aantalCilinders ? parseInt(formData.aantalCilinders) : 0,
        aantalDeuren: formData.aantalDeuren ? parseInt(formData.aantalDeuren) : 0,
        pk: formData.pk ? parseInt(formData.pk) : 0,
        motorinhoud: formData.motorinhoud ? parseInt(formData.motorinhoud) : 0,
        kmstand: formData.kmstand ? parseInt(formData.kmstand) : 0,
        prijs: formData.prijs ? parseInt(formData.prijs) : 0,
        aantalzitplaatsen: formData.aantalzitplaatsen ? parseInt(formData.aantalzitplaatsen) : 0,
        inOfEXBTW: formData.inOfEXBTW || '',
        verkocht: formData.verkocht,
      };

      const response = await fetch(`https://s-backend-rebuild-production.up.railway.app/api/cars/${car.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(processedData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      onUpdate();
      onClose();
    } catch (error) {
      alert('Error updating car: ' + error.message);
    }
  };

  const handleApplyOptions = (newOptions) => {
    setFormData(prev => ({
      ...prev,
      opties: newOptions.join(', ')
    }));
    setSelectedOptions(newOptions);
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div ref={modalRef} className="relative top-10 mx-auto p-8 border w-3/4 max-w-4xl shadow-lg rounded-lg bg-white">
        <div className="absolute top-4 right-4">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mt-3">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Auto Bewerken</h3>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Merk</label>
                <input
                  type="text"
                  name="merk"
                  value={formData.merk}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Model</label>
                <input
                  type="text"
                  name="model"
                  value={formData.model}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Uitvoering</label>
                <input
                  type="text"
                  name="uitvoering"
                  value={formData.uitvoering}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Kenteken</label>
                <input
                  type="text"
                  name="kenteken"
                  value={formData.kenteken}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Gewicht (kg)</label>
                <input
                  type="number"
                  name="gewicht"
                  value={formData.gewicht}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Transmissie</label>
                <select
                  name="transmissie"
                  value={formData.transmissie}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Selecteer transmissie</option>
                  <option value="Automaat">Automaat</option>
                  <option value="Handgeschakeld">Handgeschakeld</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Aantal Cilinders</label>
                <input
                  type="number"
                  name="aantalCilinders"
                  value={formData.aantalCilinders}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Carrosserie</label>
                <select
                  name="carrosserie"
                  value={formData.carrosserie}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Selecteer carrosserie</option>
                  <option value="Hatchback">Hatchback</option>
                  <option value="Sedan">Sedan</option>
                  <option value="Station">Station</option>
                  <option value="SUV">SUV</option>
                  <option value="Coupe">Coupe</option>
                  <option value="Cabrio">Cabrio</option>
                  <option value="MPV">MPV</option>
                  <option value="Bestelbus">Bestelbus</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Aantal Deuren</label>
                <input
                  type="number"
                  name="aantalDeuren"
                  value={formData.aantalDeuren}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">PK</label>
                <input
                  type="number"
                  name="pk"
                  value={formData.pk}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Motorinhoud (cc)</label>
                <input
                  type="number"
                  name="motorinhoud"
                  value={formData.motorinhoud}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Kmstand</label>
                <input
                  type="number"
                  name="kmstand"
                  value={formData.kmstand}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Brandstof</label>
                <select
                  name="brandstof"
                  value={formData.brandstof}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Selecteer brandstof</option>
                  <option value="Benzine">Benzine</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Elektrisch">Elektrisch</option>
                  <option value="Hybride">Hybride</option>
                  <option value="LPG">LPG</option>
                  <option value="Waterstof">Waterstof</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Kleur</label>
                <input
                  type="text"
                  name="kleur"
                  value={formData.kleur}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Interieurkleur</label>
                <input
                  type="text"
                  name="interieurkleur"
                  value={formData.interieurkleur}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">APK</label>
                <input
                  type="date"
                  name="apk"
                  value={formData.apk}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Datum</label>
                <input
                  type="date"
                  name="datum"
                  value={formData.datum}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Prijs (€)</label>
                <input
                  type="number"
                  name="prijs"
                  value={formData.prijs}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">BTW</label>
                <select
                  name="inOfEXBTW"
                  value={formData.inOfEXBTW}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Selecteer BTW</option>
                  <option value="Inclusief">Inclusief BTW</option>
                  <option value="Exclusief">Exclusief BTW</option>
                  <option value="Marge">Marge</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Aandrijving</label>
                <input
                  type="text"
                  name="aandrijving"
                  value={formData.aandrijving}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Aantal zitplaatsen</label>
                <input
                  type="number"
                  name="aantalzitplaatsen"
                  value={formData.aantalzitplaatsen}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">Bekledingsoort</label>
                <input
                  type="text"
                  name="bekledingsoort"
                  value={formData.bekledingsoort}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="flex items-center mb-4 mt-4">
                <input
                  type="checkbox"
                  id="verkocht"
                  name="verkocht"
                  checked={formData.verkocht}
                  onChange={handleCheckboxChange}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mr-2"
                />
                <label htmlFor="verkocht" className="text-gray-700 text-sm font-bold">Verkocht</label>
              </div>
            </div>

            <div className="md:col-span-2">
              <label className="block text-gray-700 text-sm font-bold mb-2">Omschrijving</label>
              <textarea
                name="omschrijving"
                value={formData.omschrijving}
                onChange={handleInputChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-gray-700 text-sm font-bold mb-2">Opties</label>
              <div className="flex gap-2 mb-2">
                <textarea
                  name="opties"
                  value={formData.opties}
                  onChange={handleInputChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                />
                <button
                  type="button"
                  onClick={() => setShowOptionsModal(true)}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition duration-200"
                >
                  Opties Toevoegen
                </button>
              </div>
            </div>

            <div className="flex justify-end gap-4 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded-lg transition duration-200"
              >
                Annuleren
              </button>
              <button
                type="submit"
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition duration-200"
              >
                Wijzigingen Opslaan
              </button>
            </div>
          </form>
        </div>
      </div>

      <OptionsModal
        isOpen={showOptionsModal}
        onClose={() => setShowOptionsModal(false)}
        onApply={handleApplyOptions}
        initialOptions={selectedOptions}
      />
    </div>
  );
};

export default EditCar;
